<small class="debug"> {{ me }} </small>
@if (!user) {
    <span>
    <app-login [setMode]="'CHECKOUT'"></app-login>
  </span>
}
<app-cart-nav></app-cart-nav>
@if (user) {
    <span>
    <div style="padding-left: 20px; padding-right: 20px">
        @if (fintechService.payerId != null) {
            <label class="header-label"
                   style="user-select: text !important;">{{ 'ai.businessId' | transloco }}: {{ fintechService.businessId }}
                , {{ 'ai.payerId' | transloco }}: {{ fintechService.payerId }}</label>
            <hr>
        } @else {
            <div>
                <app-loading type="6" [style]="{'margin-top': '200px'}"></app-loading>
            </div>
        }
        <app-fintech-contact></app-fintech-contact>
        <hr>
        <app-fintech-paymethod-editor setFintechMode="PURCHASE"></app-fintech-paymethod-editor>

        <app-fintech-shipping></app-fintech-shipping>
        <hr>

        @if (fintechService.payerId != null) {
            <div style="width: 100%; text-align: center;">
                <button
                    style="width: 200px; height: 60px; color: white; background-color: green; opacity: {{orderOpacity()}}"
                    (click)="onOrderCheckout()" class="subButton" mat-raised-button [disabled]="!canCheckout()">{{ 'ai.placeOrder' | transloco }}</button>
            </div>
        }
    </div>
  </span>
}
